import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
export const selectionLayerClear = createAction("SELECTION_LAYER_CLEAR");
export const selectionLayerUpdate = createAction("SELECTION_LAYER_UPDATE");
export default createReducer(
  {
    CARET_POSITION_UPDATE: () => {
      return {
        start: -1,
        end: -1
      };
    },
    [selectionLayerClear]: () => {
      return {
        start: -1,
        end: -1
      };
    },
    [selectionLayerUpdate]: (state, newSelectionLayer) => {
      if (!newSelectionLayer || !(newSelectionLayer.start >= 0 && newSelectionLayer.end >= 0 || newSelectionLayer.start === -1 && newSelectionLayer.end === -1)) {
        console.error(
          "we should never be here! selectionLayerUpdate must always be called with a valid selection layer"
        );
        return state;
      }
      return newSelectionLayer;
    }
  },
  {
    start: -1,
    end: -1
  }
);
